import React, { useContext, useState, useEffect, useCallback } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { Box, Button, FormControl, TextField, Typography } from "@mui/material";
import { useForm } from "react-hook-form";

import { ThemeContext } from "../../context/ThemeContext";
import { getColors } from "../../themes/theme";
// import { DefaultPhaseItem } from "./DefaultPhaseItem";
// import { OriginPhaseItem } from "./OriginPhaseItem";
import { PhaseDialog } from "./PhaseDialog";
import { CareAreaItem } from "./CareAreaItem";
import { CareSubAreaItem } from "./CareSubAreaItem";
import { CurrentPhaseItem } from "./CurrentPhaseItem";
import { AvailableTreatmentItem } from "./AvailableTreatmentItem";

import { Add } from "@mui/icons-material";
import ChangeCircleOutlinedIcon from "@mui/icons-material/ChangeCircleOutlined";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import { CarePlanItem } from "./CarePlanItem";
import { SendDialog } from "./SendDialog";
import { useAuthContext } from "../../hooks/contexts/useAuthContext";
import axios from "axios";
import { enqueueSnackbar } from "notistack";
import { useProtocolData } from "../../hooks/protocoldata/useProtocolData";
import { AvailablePhaseItem } from "./AvailablePhaseItem";
import { SelectedPhaseItem } from "./SelectedPhaseItem";

// import {
//   DndContext,
//   closestCenter,
//   KeyboardSensor,
//   PointerSensor,
//   useSensor,
//   useSensors,
// } from "@dnd-kit/core";
// import {
//   arrayMove,
//   SortableContext,
//   sortableKeyboardCoordinates,
//   verticalListSortingStrategy,
// } from "@dnd-kit/sortable";
import { GoodFaithEstimation } from "../estimation/GoodFaithEstimation";
import { CarePlanEstimation } from "../estimation/careplan/CarePlanEstimation";
import { ProtocolSelection } from "./ProtocolSelection/ProtocolSelection";
import { CitationSelection } from "./CitationSelection/CitationSelection";
import { AddTreatmentDialog } from "./AddTreatmentDialog";
import { SelectedCustomTreatmentItem } from "./SelectedCustomTreatmentItem";

export const MainContent = ({
  data,
  isPhaseChecked,
  isTreatmentChecked,
  isCitationChecked,
  isExerciseChecked,
  isLifeStyleChecked,
  isEstimationChecked,
}) => {
  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm({
    defaultValues: {
      careplanName: "",
    },
  });
  const navigate = useNavigate();
  const { user, token } = useAuthContext();
  const [allPhases, setAllPhases] = useState([]);
  const [currentPhases, setCurrentPhases] = useState([]);
  const [defaultPhaseID, setDefaultPhaseID] = useState([]);
  const [defaultPhases, setDefaultPhases] = useState([]);
  const { mainId, careId, subId } = useParams();
  const { darkMode } = useContext(ThemeContext);
  const [phaseActionType, setPhaseActionType] = useState("add");
  const [phaseDialogOpen, setPhaseDialogOpen] = useState(false);
  const [sendDialogOpen, setSendDialogOpen] = useState(false);
  const [phaseToEdit, setPhaseToEdit] = useState(null);
  const { areas } = useProtocolData(token);
  const { conditions } = useProtocolData(token);
  const [allTreatments, setAllTreatments] = useState([]);
  const [selectedTreatments, setSelectedTreatments] = useState([]);
  const [openPhaseSection, setOpenPhaseSection] = useState(false);
  const [allCarePlans, setAllCarePlans] = useState([]);
  const [conditionID, setConditionID] = useState();
  const [currentCareplanData, setCurrentCareplanData] = useState();
  const [checkedEstimations, setCheckedEstimations] = useState([]);
  const [initialCheckedIDs, setInitialCheckedIDs] = useState([]);
  const [initialProtocolIDs, setInitialProtocolIDs] = useState([]);
  const [customProtocolData, setCustomProtocolData] = useState([]);
  const [ebprotocolData, setEBProtocolData] = useState([]);
  const [selectedProtocol, setSelectedProtocol] = useState(null);

  const [selectedCitations, setSelectedCitations] = useState(null);
  const [initialCitationIDs, setInitialCitationIDs] = useState([]);
  const [openAddTreatmentDialog, setOpenAddTreatmentDialog] = useState(false); // New state for confirmation dialog
  const [customTreatments, setCustomTreatments] = useState([]); // State to hold custom treatments
  const [selectedCustomTreatments, setSelectedCustomTreatments] = useState([]);

  const reliefPhaseIds = new Set([4, 5, 1, 45]);
  const correctivePhaseIds = new Set([10, 2, 46, 6]);
  const wellnessPhaseIds = new Set([3, 7, 47]);

  const defaultGoals = [
    [
      { id: 1, title: "Reduce Pain", checked: 1 },
      { id: 2, title: "Reduce Inflammation", checked: 1 },
      { id: 3, title: "Improve Joint Function", checked: 1 },
      { id: 4, title: "Improve Posture", checked: 1 },
    ],
    [
      { id: 5, title: "Reduce / Eliminate Pain", checked: 1 },
      { id: 6, title: "Increase Range of Motion", checked: 1 },
      { id: 7, title: "Improve Joint Function", checked: 1 },
      { id: 8, title: "Improve Posture", checked: 1 },
      { id: 9, title: "Retrain Muscles", checked: 1 },
      { id: 10, title: "Strengthen Ligaments", checked: 1 },
    ],
    [
      { id: 11, title: "Maintain Structural Correction", checked: 1 },
      { id: 12, title: "Maintain Normal Range of Motion", checked: 1 },
      { id: 13, title: "Preserve Joint Health", checked: 1 },
      { id: 14, title: "Prevent Spinal Degeneration", checked: 1 },
    ],
  ];

  const handleAddCustomTreatment = async (data) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/custom-treatment`,
        {
          ...data,
          practiceid: user?.practiceId,
          area: careId === "modify" || careId === "copy" ? mainId : careId,
          acondition: careId === "modify" || careId === "copy" ? mainId : subId,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      setCustomTreatments((prev) => [...prev, response.data]);
      enqueueSnackbar("Custom Treatment Added!", { variant: "success" });
      // updateCustomTreatment(response.data); // Update the parent state
    } catch (error) {
      enqueueSnackbar("Failed to add treatment!", { variant: "error" });
    }
  };

  const handleCancelAddTreatmentDialog = () => {
    setOpenAddTreatmentDialog(false);
  };

  const handleCheckedEstimationItemsChange = useCallback(
    (checkedEstimations) => {
      setCheckedEstimations(checkedEstimations);
    },
    []
  );

  const handleCheckedCitationItemsChange = useCallback((updatedSelected) => {
    setSelectedCitations(updatedSelected);
  }, []);

  const handleProtocolSelectionChange = (protocol) => {
    setSelectedProtocol(protocol); // Update the selected protocol in the parent component
  };

  const selectedCondition = conditions[careId] || [];

  // const sensors = useSensors(
  //   useSensor(PointerSensor),
  //   useSensor(KeyboardSensor, {
  //     coordinateGetter: sortableKeyboardCoordinates,
  //   })
  // );

  // const handleDragEnd = (event) => {
  //   const { active, over } = event;

  //   if (active.id !== over.id) {
  //     setCurrentPhases((items) => {
  //       const oldIndex = items.findIndex((item) => item.id === active.id);
  //       const newIndex = items.findIndex((item) => item.id === over.id);
  //       return arrayMove(items, oldIndex, newIndex);
  //     });
  //   }
  // };

  const updateCustomTreatment = async (updatedTreatment) => {
    setCustomTreatments((prevTreatments) => {
      let updatedTreatments;
      if (updatedTreatment.deleted) {
        // Remove the deleted exercise from the state
        updatedTreatments = prevTreatments.filter(
          (treatment) => treatment.id !== updatedTreatment.id
        );
      } else {
        // Update the existing exercise
        updatedTreatments = prevTreatments.map((treatment) =>
          treatment.id === updatedTreatment.id ? updatedTreatment : treatment
        );
      }

      return updatedTreatments;
    });
  };

  useEffect(() => {
    if (!user || !token || mainId !== undefined) return;
    const fetchAllCarePlans = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/careplan/practiceid/${user?.practiceId}`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        if (response.data.join() !== allCarePlans.join()) {
          if (data.length === 0) {
            setAllCarePlans(response.data);
          } else {
            const allPlans = [];
            response.data.forEach((careplan) => {
              const conditionIds = careplan.conditions
                .split(",") // Split by comma
                .filter((id) => id.trim() !== "") // Remove empty strings
                .map(Number); // Convert to numbers

              if (data.includes(conditionIds[0])) {
                allPlans.push(careplan);
              }
            });
            if (allPlans.join() !== allCarePlans.join()) {
              setAllCarePlans(allPlans);
            }
          }
        }

        //fetch default phaseid
      } catch (err) {
        console.log("Error fetching all phases:", err);
      }
    };

    fetchAllCarePlans();
  }, [token, allCarePlans, user, mainId, data]);

  const [phaseRefreshTrigger, setPhaseRefreshTrigger] = useState(0);

  const fetchAllPhases = useCallback(async () => {
    if (!user || !token) return;
    try {
      const response = await axios.get(
        `${process.env.REACT_APP_API_URL}/phase/securitytype/${user?.securityType}/practiceid/${user?.practiceId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      // Always update phases to ensure we get the latest modified versions
      setAllPhases(response.data);

      //fetch default phaseid
      const response1 = await axios.get(
        `${process.env.REACT_APP_API_URL}/practice/${user?.practiceId}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      const result = response1.data;
      setDefaultPhaseID(
        result.phasedefaults
          ?.split(",")
          .map((id) => id.trim()) // Trim spaces
          .filter((id) => id !== "") // Remove empty values
          .map(Number) // Convert to numbers
      );
    } catch (err) {
      console.log("Error fetching all phases:", err);
    }
  }, [user, token]);

  useEffect(() => {
    fetchAllPhases();
  }, [token, user, mainId, phaseRefreshTrigger, fetchAllPhases]);

  useEffect(() => {
    const loadDefaultPhasesWithGoals = async () => {
      const filteredPhases = allPhases.filter((phase) =>
        defaultPhaseID?.includes(phase.id)
      );

      // Sort the filtered phases to match the order of defaultPhaseID
      const sortedPhases = filteredPhases.sort(
        (a, b) => defaultPhaseID.indexOf(a.id) - defaultPhaseID.indexOf(b.id)
      );

      if (sortedPhases.length > 0 && user?.practiceId && token) {
        try {
          // Fetch goals for all default phases
          const phaseIds = sortedPhases.map(phase => phase.id);
          const response = await axios.post(
            `${process.env.REACT_APP_API_URL}/planphasegoal/careplan-creation/${user?.practiceId}`,
            { phaseids: phaseIds },
            {
              headers: { Authorization: `Bearer ${token}` },
            }
          );

          const phaseGoalsMap = response.data;

          //add goals to each phase of sortedPhases
          const updatedPhases = sortedPhases.map((phase) => {
            const goals = phaseGoalsMap[phase.id] || [];
            return { ...phase, goals };
          });

          setDefaultPhases(updatedPhases);
        } catch (error) {
          console.error("Error fetching default phase goals:", error);
          // Fallback to old logic if API fails
          const updatedPhases = sortedPhases.map((phase) => {
            let goals = [];
            if (reliefPhaseIds.has(phase.id)) goals = defaultGoals[0];
            else if (correctivePhaseIds.has(phase.id)) goals = defaultGoals[1];
            else if (wellnessPhaseIds.has(phase.id)) goals = defaultGoals[2];
            else goals = [];
            return { ...phase, goals };
          });
          setDefaultPhases(updatedPhases);
        }
      } else {
        setDefaultPhases([]);
      }
    };

    loadDefaultPhasesWithGoals();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultPhaseID, allPhases, user, token]);

  useEffect(() => {
    let selectedProtocolData = {};
    let selectedType = "";

    let protocolInfo = selectedProtocol;
    if (selectedProtocol === null || selectedProtocol === undefined)
      protocolInfo = {
        id: initialProtocolIDs[0]?.protocolid,
        type: initialProtocolIDs[0]?.type,
      };

    if (protocolInfo?.type === "custom") {
      selectedProtocolData = customProtocolData.find(
        (protocol) => protocol.id === protocolInfo?.id
      );
      selectedType = "custom";
    } else if (protocolInfo?.type === "ebp") {
      selectedProtocolData = ebprotocolData.find(
        (protocol) => protocol.id === protocolInfo?.id
      );
      selectedType = "ebp";
    }

    let finalProtocolData = {};
    if (selectedType === "custom") {
      finalProtocolData = {
        customProtocolData: selectedProtocolData,
      };
    } else if (selectedType === "ebp") {
      finalProtocolData = {
        ebprotocolData: selectedProtocolData,
      };
    }

    setCurrentCareplanData({
      lifestyleChecked: isLifeStyleChecked ? 1 : 0,
      phasesData: currentPhases || [],
      phaseChecked: isPhaseChecked ? 1 : 0,
      treatmentsData: selectedTreatments || [],
      treatmentChecked: isTreatmentChecked ? 1 : 0,
      estimationData:
        checkedEstimations?.map((estimation) => estimation.id) || [],
      estimationChecked: isEstimationChecked ? 1 : 0,
      protocolData: finalProtocolData,
      exerciseChecked: isExerciseChecked ? 1 : 0,
      citationData: selectedCitations || [],
      citationChecked: isCitationChecked ? 1 : 0,
      // language: selectedLanguage,
    });
  }, [
    currentPhases,
    selectedTreatments,
    checkedEstimations,
    customProtocolData,
    ebprotocolData,
    selectedProtocol,
    initialProtocolIDs,
    // selectedLanguage,
    selectedCitations,
    isLifeStyleChecked,
    isPhaseChecked,
    isCitationChecked,
    isEstimationChecked,
    isTreatmentChecked,
    isExerciseChecked,
  ]);

  useEffect(() => {
    if (
      !user ||
      !token ||
      mainId !== "new-plan" ||
      careId === undefined ||
      subId === undefined
    ) {
      return;
    }
    setSelectedCustomTreatments([]);
    setSelectedTreatments([]);
    setOpenPhaseSection(false);
    setValue("careplanName", "");
    setCurrentPhases(defaultPhases);
    const fetchAllTreatmentsNexerciseProtocols = async () => {
      try {
        const treatmentResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/treatment/securitytype/${user.securityType}/practiceid/${user.practiceId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        const treatmentData = treatmentResponse.data;

        const conditionResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/condition/area/${careId}/acondition/${subId}/`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        const treatmentList = `,${conditionResponse.data.treatmentlist},`;
        setConditionID(conditionResponse.data.id);

        // Filter treatments matching the IDs in treatmentList
        const matchingTreatments = treatmentData.filter((treatment) =>
          treatmentList.includes(`,${treatment.id},`)
        );

        setAllTreatments((prev) => {
          if (prev.join() !== matchingTreatments.join()) {
            return matchingTreatments;
          }
          return prev;
        });

        const conditionID = conditionResponse.data.id;

        const res = await axios.post(
          `${process.env.REACT_APP_API_URL}/protocol/getwithIdNcondition`,
          {
            practiceID: user?.practiceId,
            conditionID: conditionID,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setCustomProtocolData(res.data);

        const response1 = await axios.get(
          `${process.env.REACT_APP_API_URL}/ebprotocol`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const allEBProtocolData = response1.data;
        const ebprotocolData = [];
        allEBProtocolData.forEach((protocol) => {
          const conditionsArray = protocol.conditions.split(",");
          if (conditionsArray.includes(conditionID.toString())) {
            ebprotocolData.push(protocol);
          }
        });
        setEBProtocolData(ebprotocolData);
      } catch (error) {
        console.error("Error fetching treatments:", error);
      }
    };

    fetchAllTreatmentsNexerciseProtocols();

    const fetchAllCustomTreatments = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/custom-treatment/practice/${user?.practiceId}/area/${careId}/acondition/${subId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setCustomTreatments(response.data);
      } catch (error) {
        console.error("Error fetching custom treatments:", error);
      }
    };
    fetchAllCustomTreatments();
  }, [token, user, mainId, careId, subId, setValue, defaultPhases]);

  useEffect(() => {
    if ((careId !== "modify" && careId !== "copy") || !user || !token) return;
    setOpenPhaseSection(false);
    const fetchCarePlanByID = async () => {
      try {
        const response = await axios.get(
          `${process.env.REACT_APP_API_URL}/careplan/${mainId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setValue("careplanName", response.data.careplanname);
        // setInitialLanguage(response.data.language);
        if (careId === "copy")
          setValue("careplanName", `Copy of ${response.data.careplanname}`);
        const phasesOrder = response.data.phaseorder;

        const planphaseResponse = await axios.post(
          `${process.env.REACT_APP_API_URL}/planphase/practiceid/${user?.practiceId}/careplanid/${mainId}`,
          { phaseids: phasesOrder },
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        setCurrentPhases(planphaseResponse.data);

        const plantreatmentResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/plantreatment/practiceid/${user?.practiceId}/careplanid/${mainId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        setSelectedTreatments(plantreatmentResponse.data);

        const estimationResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/plantemplate/practiceid/${user?.practiceId}/careplanid/${mainId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        setInitialCheckedIDs(estimationResponse.data);

        const protocolResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/planprotocol/practiceid/${user?.practiceId}/careplanid/${mainId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        setInitialProtocolIDs(protocolResponse.data);

        const res = await axios.get(
          `${process.env.REACT_APP_API_URL}/careplan/${mainId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        const conditionIDs = res.data.conditions;
        const conditionID = conditionIDs.split(",").filter(Boolean).map(Number);

        const conditionResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/condition/${conditionID[0]}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        const treatmentList = `,${conditionResponse.data.treatmentlist},`;

        const treatmentResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/treatment/securitytype/${user.securityType}/practiceid/${user.practiceId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        const citationResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/plancitation/practiceid/${user?.practiceId}/careplanid/${mainId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        const formattedCitations = citationResponse.data?.map((citation) => ({
          id: citation.treatmentid,
          name: citation.name,
        }));

        setInitialCitationIDs(formattedCitations);

        const treatmentData = treatmentResponse.data;
        // Filter treatments matching the IDs in treatmentList
        const matchingTreatments = treatmentData.filter((treatment) =>
          treatmentList.includes(`,${treatment.id},`)
        );

        setAllTreatments((prev) => {
          if (prev.join() !== matchingTreatments.join()) {
            return matchingTreatments;
          }
          return prev;
        });

        const res2 = await axios.post(
          `${process.env.REACT_APP_API_URL}/protocol/getwithIdNcondition`,
          {
            practiceID: user?.practiceId,
            conditionID: conditionID,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );

        setCustomProtocolData(res2.data);

        const response1 = await axios.get(
          `${process.env.REACT_APP_API_URL}/ebprotocol`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const allEBProtocolData = response1.data;
        const ebprotocolData = [];
        allEBProtocolData.forEach((protocol) => {
          const conditionsArray = protocol.conditions.split(",");
          if (conditionsArray.includes(conditionID.toString())) {
            ebprotocolData.push(protocol);
          }
        });
        setEBProtocolData(ebprotocolData);

        const customTreatmentsResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/custom-treatment/practice/${user?.practiceId}/careplan/${mainId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );

        setCustomTreatments(customTreatmentsResponse.data);

        const plancustomtreatmentResponse = await axios.get(
          `${process.env.REACT_APP_API_URL}/plancustomtreatment/careplan/${mainId}`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        setSelectedCustomTreatments(plancustomtreatmentResponse.data);
      } catch (error) {
        console.log("Error Fetch CarePlan", error);
      }
    };
    fetchCarePlanByID();
  }, [token, careId, setValue, allPhases, user, mainId, subId]);

  const handleCarePlanClicked = async (id) => {
    const response = await axios.get(
      `${process.env.REACT_APP_API_URL}/careplan/${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    // const language = response.data.language;
    const phasesOrder = response.data.phaseorder;
    const phaseChecked = response.data.phasechecked;
    const treatmentChecked = response.data.treatmentchecked;
    const citationChecked = response.data.citationchecked;
    const exerciseChecked = response.data.exercisechecked;
    const lifestyleChecked = response.data.lifestylechecked;
    const estimationChecked = response.data.estimationchecked;

    const planphaseResponse = await axios.post(
      `${process.env.REACT_APP_API_URL}/planphase/practiceid/${user?.practiceId}/careplanid/${id}`,
      { phaseids: phasesOrder },
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    const plantreatmentResponse = await axios.get(
      `${process.env.REACT_APP_API_URL}/plantreatment/practiceid/${user?.practiceId}/careplanid/${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    const plancustomtreatmentResponse = await axios.get(
      `${process.env.REACT_APP_API_URL}/plancustomtreatment/careplan/${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    const estimationResponse = await axios.get(
      `${process.env.REACT_APP_API_URL}/plantemplate/practiceid/${user?.practiceId}/careplanid/${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    const conditionIDs = response.data.conditions;
    const conditionID = conditionIDs.split(",").filter(Boolean).map(Number);

    const res = await axios.post(
      `${process.env.REACT_APP_API_URL}/protocol/getwithIdNcondition`,
      {
        practiceID: user?.practiceId,
        conditionID: conditionID,
      },
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const customProtocolData = res.data;

    const response1 = await axios.get(
      `${process.env.REACT_APP_API_URL}/ebprotocol`,
      {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }
    );
    const allEBProtocolData = response1.data;
    const ebprotocolData = [];
    allEBProtocolData.forEach((protocol) => {
      const conditionsArray = protocol.conditions.split(",");
      if (conditionsArray.includes(conditionID.toString())) {
        ebprotocolData.push(protocol);
      }
    });

    const protocolResponse = await axios.get(
      `${process.env.REACT_APP_API_URL}/planprotocol/practiceid/${user?.practiceId}/careplanid/${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    const selectedProtocol = protocolResponse.data[0];

    let selectedProtocolData = {};
    let selectedType = "";
    if (selectedProtocol?.type === "custom") {
      selectedProtocolData = customProtocolData.find(
        (protocol) => protocol.id === selectedProtocol?.protocolid
      );
      selectedType = "custom";
    } else if (selectedProtocol?.type === "ebp") {
      selectedProtocolData = ebprotocolData.find(
        (protocol) => protocol.id === selectedProtocol?.protocolid
      );
      selectedType = "ebp";
    }

    let finalProtocolData = {};
    if (selectedType === "custom") {
      finalProtocolData = {
        customProtocolData: selectedProtocolData,
      };
    } else if (selectedType === "ebp") {
      finalProtocolData = {
        ebprotocolData: selectedProtocolData,
      };
    }

    const citationResponse = await axios.get(
      `${process.env.REACT_APP_API_URL}/plancitation/practiceid/${user?.practiceId}/careplanid/${id}`,
      {
        headers: { Authorization: `Bearer ${token}` },
      }
    );

    setCurrentCareplanData({
      lifestyleChecked: lifestyleChecked,
      phasesData: planphaseResponse.data,
      phaseChecked: phaseChecked,
      treatmentsData: plantreatmentResponse.data,
      customtreatmentsData: plancustomtreatmentResponse.data,
      treatmentChecked: treatmentChecked,
      careplanID: id,
      estimationData: estimationResponse.data,
      estimationChecked: estimationChecked,
      protocolData: finalProtocolData,
      exerciseChecked: exerciseChecked,
      citationData: citationResponse.data,
      citationChecked: citationChecked,
      // language: language,
    });
    setSendDialogOpen(true);
  };

  const handleDeleteCarePlan = (id) => {
    // Remove the deleted protocol from the local state
    setAllCarePlans((prevCarePlans) =>
      prevCarePlans.filter((careplan) => careplan.id !== id)
    );
  };

  // const sendUpdatedPhases = async (updatedPhases) => {
  //   try {
  //     await axios.put(
  //       `${process.env.REACT_APP_API_URL}/practice/${user?.practiceId}`,
  //       { phasedefaults: updatedPhases },
  //       {
  //         headers: {
  //           Authorization: `Bearer ${token}`,
  //         },
  //       }
  //     );
  //   } catch (error) {
  //     console.error("Error updating default phases:", error);
  //   }
  // };

  const handleChangePhases = () => {
    setOpenPhaseSection(!openPhaseSection);
  };

  const handleSelectedTreatmentChange = (id, name, isChecked) => {
    if (isChecked === true) {
      const treatmentToAdd = allTreatments.find(
        (treatment) => treatment.name === name
      );
      // If the treatment exists and it's not already in selectedTreatments, add it
      if (
        treatmentToAdd &&
        !selectedTreatments.some((treatment) => treatment.name === name)
      ) {
        setSelectedTreatments((prevSelected) => [
          ...prevSelected,
          treatmentToAdd,
        ]);
      }
    } else if (isChecked === false) {
      if (selectedTreatments.some((treatment) => treatment.name === name)) {
        // If the treatment is already in selectedTreatments, remove it
        setSelectedTreatments((prevSelected) =>
          prevSelected.filter((treatment) => treatment.name !== name)
        );
      }
    }
  };

  const handleSelectedCustomTreatmentChange = (id, name, isChecked) => {
    if (isChecked === true) {
      const customTreatmentToAdd = customTreatments.find(
        (treatment) => treatment.id === id
      );
      // If the treatment exists and it's not already in selectedTreatments, add it
      if (
        customTreatmentToAdd &&
        !selectedCustomTreatments.some((treatment) => treatment.id === id)
      ) {
        setSelectedCustomTreatments((prevSelected) => [
          ...prevSelected,
          customTreatmentToAdd,
        ]);
      }
    } else if (isChecked === false) {
      if (selectedCustomTreatments.some((treatment) => treatment.id === id)) {
        // If the treatment is already in selectedTreatments, remove it
        setSelectedCustomTreatments((prevSelected) =>
          prevSelected.filter((treatment) => treatment.id !== id)
        );
      }
    }
  };

  const handleAddToSelectedPhase = async (id) => {
    try {
      // Fetch goals for this phase from the backend
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/planphasegoal/careplan-creation/${user?.practiceId}`,
        { phaseids: [id] },
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      );

      const phaseGoalsMap = response.data;
      const goalsForPhase = phaseGoalsMap[id] || [];

      const newSelected = [
        ...currentPhases,
        {
          ...allPhases.find((phase) => phase.id === id),
          phaseid: id,
          goals: goalsForPhase,
        },
      ];
      setCurrentPhases(newSelected);
    } catch (error) {
      console.error("Error fetching goals for phase:", error);
      // Fallback to old logic if API fails
      let goals = [];
      if (reliefPhaseIds.has(id)) goals = defaultGoals[0];
      else if (correctivePhaseIds.has(id)) goals = defaultGoals[1];
      else if (wellnessPhaseIds.has(id)) goals = defaultGoals[2];
      else goals = [];

      const newSelected = [
        ...currentPhases,
        {
          ...allPhases.find((phase) => phase.id === id),
          phaseid: id,
          goals: goals,
        },
      ];
      setCurrentPhases(newSelected);
    }
  };

  const handleDeselectPhase = (id) => {
    setCurrentPhases(currentPhases.filter((phase) => phase.id !== id));
  };

  const onSubmit = async (data) => {
    try {
      //CarePlan Response
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/careplan`,
        {
          practiceid: user?.practiceId,
          conditions: `,${conditionID}`,
          careplanname: data.careplanName,
          repeattime: "",
          duration: "",
          active: "",
          // phaseorder: currentPhases.map((phase) => phase.id).join(",") + ",",
          phaseorder: "",
          // language: selectedLanguage,
          phasechecked: isPhaseChecked === true ? 1 : 0,
          treatmentchecked: isTreatmentChecked === true ? 1 : 0,
          citationchecked: isCitationChecked === true ? 1 : 0,
          exercisechecked: isExerciseChecked === true ? 1 : 0,
          lifestylechecked: isLifeStyleChecked === true ? 1 : 0,
          estimationchecked: isEstimationChecked === true ? 1 : 0,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const newCarePlan = response.data;

      //phaseResponse
      const planPhaseResponse = await axios.post(
        `${process.env.REACT_APP_API_URL}/planphase`,
        {
          practiceid: user?.practiceId,
          careplanid: newCarePlan.id,
          phases: currentPhases,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      await axios.post(
        `${process.env.REACT_APP_API_URL}/planphasegoal/bulkcreate`,
        {
          phases: planPhaseResponse.data?.map((phase) => ({
            phaseid: phase.id,
          })),
          goals: currentPhases?.map((phase) => ({
            goals: phase.goals || "",
          })),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      await axios.put(
        `${process.env.REACT_APP_API_URL}/careplan/${newCarePlan.id}`,
        {
          phaseorder:
            planPhaseResponse.data.map((phase) => phase.id).join(",") + ",",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      //treatmentResponse
      await axios.post(
        `${process.env.REACT_APP_API_URL}/plantreatment`,
        {
          practiceid: user?.practiceId,
          careplanid: newCarePlan.id,
          treatments: selectedTreatments,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      //plancustomtreatmentResponse
      await axios.post(
        `${process.env.REACT_APP_API_URL}/plancustomtreatment/bulkcreate`,
        {
          careplanid: newCarePlan.id,
          customTreatments: selectedCustomTreatments,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const checkedEstimationIds = checkedEstimations.map(
        (estimation) => estimation.id
      );

      await axios.post(
        `${process.env.REACT_APP_API_URL}/plantemplate/bulkcreate`,
        {
          practiceid: user?.practiceId,
          careplanid: newCarePlan.id,
          templates: checkedEstimationIds,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (selectedProtocol) {
        await axios.post(
          `${process.env.REACT_APP_API_URL}/planprotocol`,
          {
            practiceid: user?.practiceId,
            careplanid: newCarePlan.id,
            protocolid: selectedProtocol?.id,
            type: selectedProtocol?.type,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      await axios.post(
        `${process.env.REACT_APP_API_URL}/plancitation/bulkcreate`,
        {
          practiceid: user?.practiceId,
          careplanid: newCarePlan.id,
          treatments: selectedCitations,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      enqueueSnackbar("Successfully Created!", { variant: "success" });

      // Trigger phase refresh to get updated phases for future care plans
      setPhaseRefreshTrigger(prev => prev + 1);

      setAllCarePlans((prevPhases) =>
        [...prevPhases, newCarePlan].sort((a, b) =>
          a.careplanname.localeCompare(b.careplanname)
        )
      );
      navigate("/care-plan");
    } catch (error) {
      console.error("Error creating careplan:", error);
      enqueueSnackbar("Error creating careplan!", { variant: "error" });
    }
  };

  const onSaveCarePlan = async (data) => {
    try {
      //CarePlan Response
      const response = await axios.put(
        `${process.env.REACT_APP_API_URL}/careplan/${mainId}`,
        {
          practiceid: user?.practiceId,
          // conditions: `,${conditionID}`,
          careplanname: data.careplanName,
          repeattime: "",
          duration: "",
          active: "",
          phaseorder: "",
          // phaseorder: currentPhases.map((phase) => phase.id).join(",") + ",",
          // language: selectedLanguage,
          phasechecked: isPhaseChecked === true ? 1 : 0,
          treatmentchecked: isTreatmentChecked === true ? 1 : 0,
          citationchecked: isCitationChecked === true ? 1 : 0,
          exercisechecked: isExerciseChecked === true ? 1 : 0,
          lifestylechecked: isLifeStyleChecked === true ? 1 : 0,
          estimationchecked: isEstimationChecked === true ? 1 : 0,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const newCarePlan = response.data;

      //phaseResponse
      const planPhaseResponse = await axios.post(
        `${process.env.REACT_APP_API_URL}/planphase/bulkedit`,
        {
          practiceid: user?.practiceId,
          careplanid: newCarePlan.id,
          phases: currentPhases,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      await axios.post(
        `${process.env.REACT_APP_API_URL}/planphasegoal/bulkcreate`,
        {
          phases: planPhaseResponse.data?.map((phase) => ({
            phaseid: phase.id,
          })),
          goals: currentPhases?.map((phase) => ({
            goals: phase.goals || "",
          })),
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      await axios.put(
        `${process.env.REACT_APP_API_URL}/careplan/${newCarePlan.id}`,
        {
          phaseorder:
            planPhaseResponse.data.map((phase) => phase.id).join(",") + ",",
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      //treatmentResponse
      await axios.post(
        `${process.env.REACT_APP_API_URL}/plantreatment/bulkedit`,
        {
          practiceid: user?.practiceId,
          careplanid: newCarePlan.id,
          treatments: selectedTreatments,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      //plancustomtreatmentResponse
      await axios.post(
        `${process.env.REACT_APP_API_URL}/plancustomtreatment/bulkedit`,
        {
          careplanid: newCarePlan.id,
          customTreatments: selectedCustomTreatments,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      const checkedEstimationIds = checkedEstimations.map(
        (estimation) => estimation.id
      );

      await axios.post(
        `${process.env.REACT_APP_API_URL}/plantemplate/bulkedit`,
        {
          practiceid: user?.practiceId,
          careplanid: newCarePlan.id,
          templates: checkedEstimationIds,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      if (selectedProtocol) {
        await axios.post(
          `${process.env.REACT_APP_API_URL}/planprotocol/bulkedit`,
          {
            practiceid: user?.practiceId,
            careplanid: newCarePlan.id,
            protocolid: selectedProtocol?.id,
            type: selectedProtocol?.type,
          },
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
      }

      await axios.post(
        `${process.env.REACT_APP_API_URL}/plancitation/bulkedit`,
        {
          practiceid: user?.practiceId,
          careplanid: newCarePlan.id,
          treatments: selectedCitations,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      enqueueSnackbar("Successfully Changed!", { variant: "success" });

      // Trigger phase refresh to get updated phases for future care plans
      setPhaseRefreshTrigger(prev => prev + 1);

      setAllCarePlans((prevPhases) =>
        [...prevPhases, newCarePlan].sort((a, b) =>
          a.careplanname.localeCompare(b.careplanname)
        )
      );
      navigate("/care-plan");
    } catch (error) {
      console.error("Error creating careplan:", error);
      enqueueSnackbar("Error creating careplan!", { variant: "error" });
    }
  };

  // const addPhaseBtnClicked = () => {
  //   setPhaseActionType("add");
  //   setPhaseToEdit({
  //     name: "",
  //     description: "",
  //     frequency: "",
  //     duration: "",
  //     active: "",
  //   });
  //   setPhaseDialogOpen(true);
  // };

  // const handleCopyClicked = (id) => {
  //   setPhaseActionType("add");
  //   const phaseToCopy = allPhases.find((phase) => phase.id === id);
  //   if (phaseToCopy) {
  //     setPhaseToEdit({
  //       ...phaseToCopy,
  //       name: `Copy of ${phaseToCopy.name}`,
  //     });
  //     setPhaseDialogOpen(true);
  //   }
  // };

  const handleEditCurrentClicked = (id) => {
    setPhaseActionType("current-edit");
    const phaseToCopy = currentPhases.find((phase) => phase.id === id);
    if (phaseToCopy) {
      setPhaseToEdit({ ...phaseToCopy });
      setPhaseDialogOpen(true);
    }
  };

  // const handleEditClicked = (id) => {
  //   setPhaseActionType("edit");
  //   const phaseToEdit = allPhases.find((phase) => phase.id === id);
  //   if (phaseToEdit) {
  //     setPhaseToEdit({ ...phaseToEdit });
  //     setPhaseDialogOpen(true);
  //   }
  // };

  // const handleRemoveClicked = (id) => {
  //   setDefaultPhases((prevPhases) => {
  //     const updatedPhases = prevPhases.filter((phase) => phase.id !== id);

  //     // Prepare the updated phase IDs as a comma-separated string
  //     const phaseIdsString =
  //       updatedPhases.map((phase) => phase.id).join(",") + ",";

  //     // Make API call to update the backend
  //     sendUpdatedPhases(phaseIdsString);

  //     return updatedPhases;
  //   });
  // };

  // const handleSetDefault = async (id) => {
  //   // Update the state first
  //   setDefaultPhases((prevPhases) => {
  //     const newPhase = allPhases.find((phase) => phase.id === id);
  //     const alreadyExists = prevPhases.some((phase) => phase.id === id);

  //     // Only add if it doesn't exist
  //     const updatedPhases =
  //       newPhase && !alreadyExists ? [...prevPhases, newPhase] : prevPhases;

  //     const phaseIdsString =
  //       updatedPhases.map((phase) => phase.id).join(",") + ",";

  //     sendUpdatedPhases(phaseIdsString);

  //     return updatedPhases;
  //   });
  // };

  const handleCopyNewPhase = async (updatedPhase) => {
    try {
      const response = await axios.post(
        `${process.env.REACT_APP_API_URL}/phase`,
        {
          practiceid: user?.practiceId,
          name: updatedPhase.name,
          description: updatedPhase.description,
          repeattime: updatedPhase.repeattime,
          duration: updatedPhase.duration,
          active: updatedPhase.active,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      enqueueSnackbar("Successfully Copied!", { variant: "success" });
      const newID = response.data.id;
      setAllPhases((prevPhases) =>
        [
          ...prevPhases,
          {
            ...updatedPhase,
            id: newID,
          },
        ].sort((a, b) => a.name.localeCompare(b.name))
      );
    } catch (error) {
      console.error("Error adding default phases:", error);
    }
    setPhaseDialogOpen(false);
  };

  const handleDeletePhase = async (id) => {
    try {
      await axios.delete(`${process.env.REACT_APP_API_URL}/phase/${id}`, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });

      setAllPhases((prevPhases) => {
        const updatedPhases = prevPhases.filter((phase) => phase.id !== id);
        return updatedPhases;
      });

      enqueueSnackbar("Successfully Deleted!", { variant: "success" });
    } catch (error) {
      console.error("Error adding default phases:", error);
    }
    setPhaseDialogOpen(false);
  };

  const handleEditPhase = async (editPhase) => {
    try {
      await axios.put(
        `${process.env.REACT_APP_API_URL}/phase/${editPhase.id}`,
        {
          ...editPhase,
        },
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setAllPhases((prevPhases) =>
        prevPhases.map((phase) =>
          phase.id === editPhase.id ? editPhase : phase
        )
      );

      enqueueSnackbar("Successfully Edited!", { variant: "success" });
    } catch (error) {
      console.error("Error adding default phases:", error);
    }
    setPhaseDialogOpen(false);
  };

  const handleEditCurrentPhase = (editPhase) => {
    setCurrentPhases((prevPhases) =>
      prevPhases.map((phase) => (phase.id === editPhase.id ? editPhase : phase))
    );
    setPhaseDialogOpen(false);
  };

  const handleCloseDialog = () => {
    setPhaseDialogOpen(false);
    setPhaseToEdit(null);
  };

  return (
    <Box display="flex" flexDirection="column" flexGrow={1}>
      <Box sx={{ padding: { xs: 3, md: 5, xl: 8 } }}>
        <>
          {mainId === undefined && (
            <Box>
              <Typography
                sx={{
                  fontFamily: "Poppins",
                  fontSize: { xs: "24px", sm: "28px" },
                  fontWeight: 500,
                  color: darkMode
                    ? getColors.drawerTextDark
                    : getColors.thumbnailTextLight,
                  textAlign: "left",
                  mb: 5,
                }}
              >
                Treatment Care Plans
              </Typography>
              <Box
                display="grid"
                sx={{
                  gridTemplateColumns: {
                    xs: "repeat(1, minmax(0, 1fr))",
                    sm: "repeat(2, minmax(0, 1fr))",
                    md: "repeat(1, minmax(0, 1fr))",
                    lg: "repeat(2, minmax(0, 1fr))",
                    xl: "repeat(3, minmax(0, 1fr))",
                  },
                }}
                gap={3}
              >
                {allCarePlans.map((careplan, index) => (
                  <CarePlanItem
                    key={index}
                    {...careplan}
                    onClick={() => {
                      handleCarePlanClicked(careplan.id);
                    }}
                    onDelete={handleDeleteCarePlan}
                  />
                ))}
              </Box>
            </Box>
          )}
        </>
        {/* <>
          {mainId === "default-phases" && (
            <Box>
              <Box
                display={"flex"}
                justifyContent={"space-between"}
                flexDirection={{
                  xs: "column",
                  sm: "row",
                  md: "column",
                  lg: "row",
                }}
                alignItems={"center"}
                sx={{
                  mb: 5,
                }}
              >
                <Typography
                  sx={{
                    fontFamily: "Poppins",
                    fontSize: {
                      xs: "24px",
                      sm: "28px",
                    },
                    fontWeight: 500,
                    color: darkMode
                      ? getColors.drawerTextDark
                      : getColors.thumbnailTextLight,
                    textAlign: "left",
                    mr: "auto",
                    mb: { xs: 2, sm: 0 },
                  }}
                >
                  Default Phases
                </Typography>
                <Button
                  variant="contained"
                  startIcon={<Add />}
                  sx={{
                    fontFamily: "Poppins",
                    fontSize: { xs: "16px", sm: "20px" },
                    px: "16px",
                    py: { xs: 1, sm: "12px" },
                    background: darkMode ? "#2D2E30" : "#E6E6E6",
                    color: darkMode
                      ? getColors.primaryTextDark
                      : getColors.secondaryTextLight,
                    "&:hover": {
                      color: getColors.primaryTextDark,
                    },
                    ml: "auto",
                  }}
                  onClick={addPhaseBtnClicked}
                >
                  Add Phase
                </Button>
              </Box>
              <Box
                display="grid"
                sx={{
                  mb: 10,
                  gridTemplateColumns: {
                    xs: "repeat(1, minmax(0, 1fr))",
                    sm: "repeat(2, minmax(0, 1fr))",
                    md: "repeat(1, minmax(0, 1fr))",
                    lg: "repeat(2, minmax(0, 1fr))",
                    xl: "repeat(3, minmax(0, 1fr))",
                  },
                }}
                gap={3}
              >
                {defaultPhases.map((phase, index) => (
                  <DefaultPhaseItem
                    key={index}
                    {...phase}
                    onRemove={handleRemoveClicked}
                  />
                ))}
              </Box>
              <Typography
                sx={{
                  fontFamily: "Poppins",
                  fontSize: "28px",
                  fontWeight: 500,
                  color: darkMode
                    ? getColors.drawerTextDark
                    : getColors.thumbnailTextLight,
                  textAlign: "left",
                  mb: 5,
                }}
              >
                All Phases
              </Typography>
              <Box
                display="grid"
                sx={{
                  gridTemplateColumns: {
                    xs: "repeat(1, minmax(0, 1fr))",
                    sm: "repeat(2, minmax(0, 1fr))",
                    md: "repeat(1, minmax(0, 1fr))",
                    lg: "repeat(2, minmax(0, 1fr))",
                    xl: "repeat(3, minmax(0, 1fr))",
                  },
                }}
                gap={3}
              >
                {allPhases.map((phase, index) => (
                  <OriginPhaseItem
                    key={index}
                    {...phase}
                    onSetDefault={handleSetDefault}
                    onCopyPhase={handleCopyClicked}
                    onEditPhase={handleEditClicked}
                  />
                ))}
              </Box>
            </Box>
          )}
        </> */}
        <>{mainId === "estimation" && <GoodFaithEstimation />}</>
        <>
          {mainId === "new-plan" &&
            (!careId ? (
              <Box>
                <Typography
                  sx={{
                    fontFamily: "Poppins",
                    fontSize: { xs: "24px", sm: "28px" },
                    fontWeight: 500,
                    color: darkMode
                      ? getColors.drawerTextDark
                      : getColors.thumbnailTextLight,
                    textAlign: "left",
                    mb: 5,
                  }}
                >
                  Create Care Plan by selecting Area
                </Typography>
                <Box
                  display="grid"
                  gap={3}
                  sx={{
                    mb: 7,
                    gridTemplateColumns: {
                      xs: "repeat(1, minmax(0, 1fr))",
                      sm: "repeat(2, minmax(0, 1fr))",
                      md: "repeat(1, minmax(0, 1fr))",
                      lg: "repeat(2, minmax(0, 1fr))",
                      xl: "repeat(3, minmax(0, 1fr))",
                    },
                  }}
                >
                  {areas.map((carearea, index) => (
                    <CareAreaItem key={index} {...carearea} />
                  ))}
                </Box>
              </Box>
            ) : (
              <Box>
                {!subId ? (
                  <Box>
                    <Typography
                      sx={{
                        fontFamily: "Poppins",
                        fontSize: { xs: "24px", sm: "28px" },
                        fontWeight: 500,
                        color: darkMode
                          ? getColors.drawerTextDark
                          : getColors.thumbnailTextLight,
                        textAlign: "left",
                        mb: 5,
                      }}
                    >
                      Create Care Plan by selecting Conditions
                    </Typography>
                    <Box
                      display="grid"
                      sx={{
                        gridTemplateColumns: {
                          xs: "repeat(1, minmax(0, 1fr))",
                          sm: "repeat(1, minmax(0, 1fr))",
                          md: "repeat(1, minmax(0, 1fr))",
                          lg: "repeat(1, minmax(0, 1fr))",
                          xl: "repeat(2, minmax(0, 1fr))",
                        },
                      }}
                      gap={4}
                    >
                      {selectedCondition.map((condition, index) => (
                        <CareSubAreaItem key={index} condition={condition} />
                      ))}
                    </Box>
                  </Box>
                ) : (
                  <Box>
                    <Box
                      display={"flex"}
                      flexDirection={{ xs: "column", lg: "row" }}
                      justifyContent={"space-between"}
                      alignItems={"center"}
                      sx={{
                        mb: 3,
                      }}
                    >
                      <Typography
                        sx={{
                          fontSize: { xs: "18px", sm: "22px" },
                          fontWeight: 600,
                          color: darkMode
                            ? getColors.drawerTextDark
                            : getColors.thumbnailTextLight,
                          mr: "auto",
                          mb: { xs: 2, sm: 0, md: 2, lg: 0 },
                        }}
                      >
                        {`Create Care Plan for ${careId} ${subId}`}
                      </Typography>
                    </Box>
                    <form onSubmit={handleSubmit(onSubmit)}>
                      <Box
                        display={"flex"}
                        flexDirection={{ xs: "column", lg: "row" }}
                        sx={{
                          padding: { xs: 2, sm: "20px" },
                          fontSize: { xs: "16px", sm: "20px" },
                          borderWidth: 1,
                          borderStyle: "solid",
                          borderColor: darkMode
                            ? getColors.appBarBorderDark
                            : getColors.appBarBorderLight,
                          gap: 4,
                          mb: 4,
                        }}
                      >
                        <FormControl fullWidth>
                          <TextField
                            fullWidth
                            variant="filled"
                            placeholder="Enter Care Plan Name"
                            {...register("careplanName", {
                              required: "Care Plan Name is required",
                            })}
                            error={!!errors.careplanName}
                            helperText={errors.careplanName?.message}
                          />
                        </FormControl>
                        <Button
                          type="submit"
                          variant="contained"
                          sx={{
                            height: { xs: "50px", sm: "64px" },
                            fontSize: "18px",
                            fontWeight: 500,
                            fontFamily: "Poppins",
                            px: 8,
                            py: 2,
                            borderRadius: "5px",
                          }}
                        >
                          Create
                        </Button>
                      </Box>
                    </form>

                    <Box
                      display={isPhaseChecked ? "flex" : "none"}
                      flexDirection={{ xs: "column", lg: "row" }}
                      justifyContent={"space-between"}
                      sx={{ mb: 5 }}
                      alignItems={"center"}
                    >
                      <Typography
                        sx={{
                          fontSize: { xs: "24px", sm: "28px" },
                          fontWeight: 500,
                          color: darkMode
                            ? getColors.drawerTextDark
                            : getColors.thumbnailTextLight,
                          textAlign: "left",
                          mr: "auto",
                          mb: { xs: 1, sm: 0, md: 1, lg: 0 },
                        }}
                      >
                        {openPhaseSection
                          ? "Selected Phases"
                          : "Phases of Care"}
                      </Typography>

                      <Button
                        variant="contained"
                        startIcon={
                          openPhaseSection ? (
                            <SaveOutlinedIcon
                              style={{ fontSize: 28, marginRight: 8 }}
                            />
                          ) : (
                            <ChangeCircleOutlinedIcon
                              style={{ fontSize: 28, marginRight: 8 }}
                            />
                          )
                        }
                        disabled={!isPhaseChecked}
                        sx={{
                          fontFamily: "Poppins",
                          fontSize: { xs: "16px", sm: "20px" },
                          py: "12px",
                          background: darkMode ? "#2D2E30" : "#E6E6E6",
                          color: darkMode
                            ? getColors.primaryTextDark
                            : getColors.secondaryTextLight,
                          ml: "auto",
                          "&:hover": {
                            color: getColors.primaryTextDark,
                          },
                        }}
                        onClick={handleChangePhases}
                      >
                        {openPhaseSection ? "Save Changes" : "Change Phases"}
                      </Button>
                    </Box>

                    {openPhaseSection ? (
                      <Box
                        display={isPhaseChecked ? "grid" : "none"}
                        sx={{
                          gridTemplateColumns: {
                            xs: "repeat(1, minmax(0, 1fr))",
                            sm: "repeat(2, minmax(0, 1fr))",
                            md: "repeat(1, minmax(0, 1fr))",
                            lg: "repeat(2, minmax(0, 1fr))",
                            xl: "repeat(3, minmax(0, 1fr))",
                          },
                        }}
                        gap={4}
                        mb={8}
                      >
                        {/* <DndContext
                          sensors={sensors}
                          collisionDetection={closestCenter}
                          onDragEnd={handleDragEnd}
                        >
                          <SortableContext
                            items={currentPhases.map((phase) => phase.id)}
                            strategy={verticalListSortingStrategy}
                          > */}
                        {currentPhases.map((phase, index) => (
                          <SelectedPhaseItem
                            key={index}
                            id={phase.id}
                            {...phase}
                            onRemove={handleDeselectPhase}
                          />
                        ))}
                        {/* </SortableContext>
                        </DndContext> */}
                      </Box>
                    ) : (
                      <Box
                        display={isPhaseChecked ? "grid" : "none"}
                        sx={{
                          gridTemplateColumns: {
                            xs: "repeat(1, minmax(0, 1fr))",
                            sm: "repeat(2, minmax(0, 1fr))",
                            md: "repeat(1, minmax(0, 1fr))",
                            lg: "repeat(2, minmax(0, 1fr))",
                            xl: "repeat(3, minmax(0, 1fr))",
                          },
                        }}
                        gap={4}
                        mb={8}
                      >
                        {currentPhases.map((phase, index) => (
                          <CurrentPhaseItem
                            key={index}
                            {...phase}
                            disabled={!isPhaseChecked}
                            onEdit={handleEditCurrentClicked}
                          />
                        ))}
                      </Box>
                    )}
                    {openPhaseSection && (
                      <Box>
                        <Typography
                          sx={{
                            fontSize: { xs: "24px", sm: "28px" },
                            fontWeight: 500,
                            color: darkMode
                              ? getColors.drawerTextDark
                              : getColors.thumbnailTextLight,
                            textAlign: "left",
                            mb: "30px",
                          }}
                        >
                          Available Phases
                        </Typography>
                        <Box
                          display="grid"
                          sx={{
                            gridTemplateColumns: {
                              xs: "repeat(1, minmax(0, 1fr))",
                              sm: "repeat(2, minmax(0, 1fr))",
                              md: "repeat(1, minmax(0, 1fr))",
                              lg: "repeat(2, minmax(0, 1fr))",
                              xl: "repeat(3, minmax(0, 1fr))",
                            },
                          }}
                          gap={4}
                          mb={8}
                        >
                          {allPhases
                            .filter(
                              (phase) =>
                                !currentPhases.some(
                                  (currentPhase) => currentPhase.id === phase.id
                                )
                            ) // Filter out phases that already exist in currentPhases
                            .map((phase, index) => (
                              <AvailablePhaseItem
                                key={index}
                                {...phase}
                                onAdd={handleAddToSelectedPhase}
                              />
                            ))}
                        </Box>
                      </Box>
                    )}

                    {!openPhaseSection && (
                      <Box>
                        <Box
                          sx={{
                            display: isTreatmentChecked ? "flex" : "none",
                            mb: 5,
                          }}
                          flexDirection={{ xs: "column", lg: "row" }}
                          justifyContent={"space-between"}
                        >
                          <Typography
                            sx={{
                              fontSize: { xs: "24px", sm: "28px" },
                              fontWeight: 500,
                              color: darkMode
                                ? getColors.drawerTextDark
                                : getColors.thumbnailTextLight,
                              textAlign: "left",
                            }}
                          >
                            Treatments
                          </Typography>
                          <Button
                            variant="contained"
                            startIcon={
                              <Add style={{ fontSize: 28, marginRight: 8 }} />
                            }
                            sx={{
                              fontFamily: "Poppins",
                              fontSize: { xs: "16px", sm: "20px" },
                              py: "12px",
                              background: darkMode ? "#2D2E30" : "#E6E6E6",
                              color: darkMode
                                ? getColors.primaryTextDark
                                : getColors.secondaryTextLight,
                              ml: "auto",
                              "&:hover": {
                                color: getColors.primaryTextDark,
                              },
                            }}
                            onClick={() => setOpenAddTreatmentDialog(true)}
                          >
                            {"Add Treatment"}
                          </Button>
                        </Box>
                        <Typography
                          sx={{
                            display: isTreatmentChecked ? "block" : "none",
                            fontSize: { xs: "18px", sm: "22px" },
                            fontWeight: 500,
                            color: darkMode
                              ? getColors.drawerTextDark
                              : getColors.thumbnailTextLight,
                            textAlign: "left",
                            mb: 2,
                          }}
                        >
                          General
                        </Typography>
                        <Box
                          display={isTreatmentChecked ? "grid" : "none"}
                          sx={{
                            gridTemplateColumns: {
                              xs: "repeat(1, minmax(0, 1fr))",
                              sm: "repeat(2, minmax(0, 1fr))",
                              md: "repeat(1, minmax(0, 1fr))",
                              lg: "repeat(2, minmax(0, 1fr))",
                              xl: "repeat(3, minmax(0, 1fr))",
                            },
                          }}
                          gap={4}
                          mb={4}
                        >
                          {allTreatments.map((treatment, index) => (
                            <AvailableTreatmentItem
                              key={index}
                              {...treatment}
                              onCheck={handleSelectedTreatmentChange}
                              isChecked={selectedTreatments.some(
                                (selected) => selected.name === treatment.name
                              )}
                            />
                          ))}
                        </Box>
                        <Typography
                          sx={{
                            display:
                              isTreatmentChecked && customTreatments.length > 0
                                ? "block"
                                : "none",
                            fontSize: { xs: "18px", sm: "22px" },
                            fontWeight: 500,
                            color: darkMode
                              ? getColors.drawerTextDark
                              : getColors.thumbnailTextLight,
                            textAlign: "left",
                            mb: 2,
                          }}
                        >
                          Custom
                        </Typography>
                        <Box
                          display={isTreatmentChecked ? "grid" : "none"}
                          sx={{
                            gridTemplateColumns: {
                              xs: "repeat(1, minmax(0, 1fr))",
                              sm: "repeat(2, minmax(0, 1fr))",
                              md: "repeat(1, minmax(0, 1fr))",
                              lg: "repeat(2, minmax(0, 1fr))",
                              xl: "repeat(3, minmax(0, 1fr))",
                            },
                          }}
                          gap={4}
                          mb={8}
                        >
                          {customTreatments.map((treatment, index) => (
                            <SelectedCustomTreatmentItem
                              key={index}
                              {...treatment}
                              onCheck={handleSelectedCustomTreatmentChange}
                              isChecked={selectedCustomTreatments.some(
                                (selected) => selected.id === treatment.id
                              )}
                              onTreatmentUpdate={updateCustomTreatment}
                            />
                          ))}
                        </Box>
                        <CitationSelection
                          citations={selectedTreatments}
                          onSelectionChange={handleCheckedCitationItemsChange}
                          checkedIDs={null}
                          disabled={!isCitationChecked}
                        />
                        <ProtocolSelection
                          customProtocolData={customProtocolData}
                          ebprotocolData={ebprotocolData}
                          onSelectionChange={handleProtocolSelectionChange} // Pass the callback
                          checkedID={null}
                          disabled={!isExerciseChecked}
                        />
                        <CarePlanEstimation
                          onCheckedItemsChange={
                            handleCheckedEstimationItemsChange
                          }
                          checkedIDs={null}
                          disabled={!isEstimationChecked}
                        />
                      </Box>
                    )}
                  </Box>
                )}
              </Box>
            ))}
        </>
        <>
          {mainId !== undefined &&
            // mainId !== "default-phases" &&
            mainId !== "estimation" &&
            mainId !== "new-plan" &&
            mainId !== "ai-wizard" &&
            (careId === "modify" ? (
              <Box>
                <Box
                  display={"flex"}
                  flexDirection={{ xs: "column", lg: "row" }}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  sx={{ mb: 3 }}
                >
                  <Typography
                    sx={{
                      fontSize: { xs: "18px", sm: "22px" },
                      fontWeight: 600,
                      color: darkMode
                        ? getColors.drawerTextDark
                        : getColors.thumbnailTextLight,
                      mr: "auto",
                      mb: { xs: 2, sm: 0, md: 2, lg: 0 },
                    }}
                  >
                    {/* must Edittitle */}
                    {`Edit Care Plan `}
                  </Typography>
                </Box>

                <form onSubmit={handleSubmit(onSaveCarePlan)}>
                  <Box
                    display={"flex"}
                    flexDirection={{ xs: "column", lg: "row" }}
                    sx={{
                      padding: { xs: 2, sm: "20px" },
                      fontSize: { xs: "16px", sm: "20px" },
                      borderWidth: 1,
                      borderStyle: "solid",
                      borderColor: darkMode
                        ? getColors.appBarBorderDark
                        : getColors.appBarBorderLight,
                      gap: 4,
                      mb: 4,
                    }}
                  >
                    <FormControl fullWidth>
                      <TextField
                        fullWidth
                        variant="filled"
                        placeholder="Enter Care Plan Name"
                        // careplanname should be copied via backend
                        {...register("careplanName", {
                          required: "Care Plan Name is required",
                        })}
                        error={!!errors.careplanName}
                        helperText={errors.careplanName?.message}
                      />
                    </FormControl>
                    <Button
                      type="submit"
                      variant="contained"
                      sx={{
                        height: { xs: "50px", sm: "64px" },
                        fontSize: "18px",
                        fontWeight: 500,
                        fontFamily: "Poppins",
                        px: 8,
                        py: 2,
                        borderRadius: "5px",
                      }}
                    >
                      Save
                    </Button>
                  </Box>
                </form>
                <Box
                  display={isPhaseChecked ? "flex" : "none"}
                  flexDirection={{ xs: "column", lg: "row" }}
                  justifyContent={"space-between"}
                  sx={{ mb: 5 }}
                  alignItems={"center"}
                >
                  <Typography
                    sx={{
                      fontSize: { xs: "24px", sm: "28px" },
                      fontWeight: 500,
                      color: darkMode
                        ? getColors.drawerTextDark
                        : getColors.thumbnailTextLight,
                      textAlign: "left",
                      mr: "auto",
                      mb: { xs: 1, sm: 0, md: 1, lg: 0 },
                    }}
                  >
                    {openPhaseSection ? "Selected Phases" : "Phases of Care"}
                  </Typography>

                  <Button
                    variant="contained"
                    startIcon={
                      openPhaseSection ? (
                        <SaveOutlinedIcon
                          style={{ fontSize: 28, marginRight: 8 }}
                        />
                      ) : (
                        <ChangeCircleOutlinedIcon
                          style={{ fontSize: 28, marginRight: 8 }}
                        />
                      )
                    }
                    disabled={!isPhaseChecked}
                    sx={{
                      fontFamily: "Poppins",
                      fontSize: { xs: "16px", sm: "20px" },
                      py: "12px",
                      background: darkMode ? "#2D2E30" : "#E6E6E6",
                      color: darkMode
                        ? getColors.primaryTextDark
                        : getColors.secondaryTextLight,
                      ml: "auto",
                      "&:hover": {
                        color: getColors.primaryTextDark,
                      },
                    }}
                    onClick={handleChangePhases}
                  >
                    {openPhaseSection ? "Save Changes" : "Change Phases"}
                  </Button>
                </Box>
                {openPhaseSection ? (
                  <Box
                    display={isPhaseChecked ? "grid" : "none"}
                    sx={{
                      gridTemplateColumns: {
                        xs: "repeat(1, minmax(0, 1fr))",
                        sm: "repeat(2, minmax(0, 1fr))",
                        md: "repeat(1, minmax(0, 1fr))",
                        lg: "repeat(2, minmax(0, 1fr))",
                        xl: "repeat(3, minmax(0, 1fr))",
                      },
                    }}
                    gap={4}
                    mb={8}
                  >
                    {/* <DndContext
                      sensors={sensors}
                      collisionDetection={closestCenter}
                      onDragEnd={handleDragEnd}
                    >
                      <SortableContext
                        items={currentPhases.map((phase) => phase.id)}
                        strategy={verticalListSortingStrategy}
                      > */}
                    {currentPhases.map((phase, index) => (
                      <SelectedPhaseItem
                        key={index}
                        id={phase.id}
                        {...phase}
                        onRemove={handleDeselectPhase}
                      />
                    ))}
                    {/* </SortableContext>
                    </DndContext> */}
                  </Box>
                ) : (
                  <Box
                    display={isPhaseChecked ? "grid" : "none"}
                    sx={{
                      gridTemplateColumns: {
                        xs: "repeat(1, minmax(0, 1fr))",
                        sm: "repeat(2, minmax(0, 1fr))",
                        md: "repeat(1, minmax(0, 1fr))",
                        lg: "repeat(2, minmax(0, 1fr))",
                        xl: "repeat(3, minmax(0, 1fr))",
                      },
                    }}
                    gap={4}
                    mb={8}
                  >
                    {currentPhases.map((phase, index) => (
                      <CurrentPhaseItem
                        key={index}
                        {...phase}
                        disabled={!isPhaseChecked}
                        onEdit={handleEditCurrentClicked}
                      />
                    ))}
                  </Box>
                )}
                {openPhaseSection && (
                  <Box>
                    <Typography
                      sx={{
                        fontSize: { xs: "24px", sm: "28px" },
                        fontWeight: 500,
                        color: darkMode
                          ? getColors.drawerTextDark
                          : getColors.thumbnailTextLight,
                        textAlign: "left",
                        mb: "30px",
                      }}
                    >
                      Available Phases
                    </Typography>
                    <Box
                      display="grid"
                      sx={{
                        gridTemplateColumns: {
                          xs: "repeat(1, minmax(0, 1fr))",
                          sm: "repeat(2, minmax(0, 1fr))",
                          md: "repeat(1, minmax(0, 1fr))",
                          lg: "repeat(2, minmax(0, 1fr))",
                          xl: "repeat(3, minmax(0, 1fr))",
                        },
                      }}
                      gap={4}
                      mb={8}
                    >
                      {allPhases
                        .filter(
                          (phase) =>
                            !currentPhases.some(
                              (currentPhase) =>
                                currentPhase.phaseid === phase.id
                            )
                        ) // Filter out phases that already exist in currentPhases
                        .map((phase, index) => (
                          <AvailablePhaseItem
                            key={index}
                            {...phase}
                            onAdd={handleAddToSelectedPhase}
                          />
                        ))}
                    </Box>
                  </Box>
                )}

                {!openPhaseSection && (
                  <Box>
                    <Box
                      sx={{
                        display: isTreatmentChecked ? "flex" : "none",
                        mb: 5,
                      }}
                      flexDirection={{ xs: "column", lg: "row" }}
                      justifyContent={"space-between"}
                    >
                      <Typography
                        sx={{
                          fontSize: { xs: "24px", sm: "28px" },
                          fontWeight: 500,
                          color: darkMode
                            ? getColors.drawerTextDark
                            : getColors.thumbnailTextLight,
                          textAlign: "left",
                        }}
                      >
                        Treatments
                      </Typography>
                      <Button
                        variant="contained"
                        startIcon={
                          <Add style={{ fontSize: 28, marginRight: 8 }} />
                        }
                        sx={{
                          fontFamily: "Poppins",
                          fontSize: { xs: "16px", sm: "20px" },
                          py: "12px",
                          background: darkMode ? "#2D2E30" : "#E6E6E6",
                          color: darkMode
                            ? getColors.primaryTextDark
                            : getColors.secondaryTextLight,
                          ml: "auto",
                          "&:hover": {
                            color: getColors.primaryTextDark,
                          },
                        }}
                        onClick={() => setOpenAddTreatmentDialog(true)}
                      >
                        {"Add Treatment"}
                      </Button>
                    </Box>
                    <Typography
                      sx={{
                        display: isTreatmentChecked ? "block" : "none",
                        fontSize: { xs: "18px", sm: "22px" },
                        fontWeight: 500,
                        color: darkMode
                          ? getColors.drawerTextDark
                          : getColors.thumbnailTextLight,
                        textAlign: "left",
                        mb: 2,
                      }}
                    >
                      General
                    </Typography>
                    <Box
                      display={isTreatmentChecked ? "grid" : "none"}
                      sx={{
                        gridTemplateColumns: {
                          xs: "repeat(1, minmax(0, 1fr))",
                          sm: "repeat(2, minmax(0, 1fr))",
                          md: "repeat(1, minmax(0, 1fr))",
                          lg: "repeat(2, minmax(0, 1fr))",
                          xl: "repeat(3, minmax(0, 1fr))",
                        },
                      }}
                      gap={4}
                      mb={4}
                    >
                      {allTreatments.map((treatment, index) => (
                        <AvailableTreatmentItem
                          key={index}
                          {...treatment}
                          onCheck={handleSelectedTreatmentChange}
                          isChecked={selectedTreatments.some(
                            (selected) => selected.name === treatment.name
                          )}
                        />
                      ))}
                    </Box>
                    <Typography
                      sx={{
                        display:
                          isTreatmentChecked && customTreatments.length > 0,
                        fontSize: { xs: "18px", sm: "22px" },
                        fontWeight: 500,
                        color: darkMode
                          ? getColors.drawerTextDark
                          : getColors.thumbnailTextLight,
                        textAlign: "left",
                        mb: 2,
                      }}
                    >
                      Custom
                    </Typography>
                    <Box
                      display={isTreatmentChecked ? "grid" : "none"}
                      sx={{
                        gridTemplateColumns: {
                          xs: "repeat(1, minmax(0, 1fr))",
                          sm: "repeat(2, minmax(0, 1fr))",
                          md: "repeat(1, minmax(0, 1fr))",
                          lg: "repeat(2, minmax(0, 1fr))",
                          xl: "repeat(3, minmax(0, 1fr))",
                        },
                      }}
                      gap={4}
                      mb={8}
                    >
                      {customTreatments.map((treatment, index) => (
                        <SelectedCustomTreatmentItem
                          key={index}
                          {...treatment}
                          onCheck={handleSelectedCustomTreatmentChange}
                          isChecked={selectedCustomTreatments.some(
                            (selected) => selected.id === treatment.id
                          )}
                          onTreatmentUpdate={updateCustomTreatment}
                        />
                      ))}
                    </Box>
                    <CitationSelection
                      citations={selectedTreatments}
                      onSelectionChange={handleCheckedCitationItemsChange}
                      checkedIDs={initialCitationIDs}
                      disabled={!isCitationChecked}
                    />
                    <ProtocolSelection
                      customProtocolData={customProtocolData}
                      ebprotocolData={ebprotocolData}
                      onSelectionChange={handleProtocolSelectionChange} // Pass the callback
                      checkedID={initialProtocolIDs} // IDs to be pre-checked
                      disabled={!isExerciseChecked}
                    />
                    <CarePlanEstimation
                      onCheckedItemsChange={handleCheckedEstimationItemsChange}
                      checkedIDs={initialCheckedIDs} // IDs to be pre-checked
                      disabled={!isEstimationChecked}
                    />
                  </Box>
                )}
              </Box>
            ) : (
              <Box>
                <Box
                  display="flex"
                  flexDirection={{ xs: "column", lg: "row" }}
                  justifyContent={"space-between"}
                  alignItems={"center"}
                  sx={{
                    mb: 3,
                  }}
                >
                  <Typography
                    sx={{
                      fontSize: { xs: "18px", sm: "22px" },
                      fontWeight: 600,
                      color: darkMode
                        ? getColors.drawerTextDark
                        : getColors.thumbnailTextLight,
                      mr: "auto",
                      mb: { xs: 2, sm: 0, md: 2, lg: 0 },
                    }}
                  >
                    {/* must Edittitle */}
                    {`Copy as New Care Plan`}
                  </Typography>
                </Box>
                <form onSubmit={handleSubmit(onSubmit)}>
                  <Box
                    display={"flex"}
                    sx={{
                      padding: { xs: 2, sm: "20px" },
                      fontSize: { xs: "16px", sm: "20px" },
                      flexDirection: { xs: "column", lg: "row" },
                      borderWidth: 1,
                      borderStyle: "solid",
                      borderColor: darkMode
                        ? getColors.appBarBorderDark
                        : getColors.appBarBorderLight,
                      gap: 4,
                      mb: 4,
                    }}
                  >
                    <FormControl fullWidth>
                      <TextField
                        fullWidth
                        variant="filled"
                        placeholder="Enter Care Plan Name"
                        // careplanname should be copied via backend
                        {...register("careplanName", {
                          required: "Care Plan Name is required",
                        })}
                        error={!!errors.careplanName}
                        helperText={errors.careplanName?.message}
                      />
                    </FormControl>
                    <Button
                      type="submit"
                      variant="contained"
                      sx={{
                        height: { xs: "50px", sm: "64px" },
                        fontSize: "18px",
                        fontWeight: 500,
                        fontFamily: "Poppins",
                        px: 8,
                        py: 2,
                        borderRadius: "5px",
                      }}
                    >
                      Add
                    </Button>
                  </Box>
                </form>

                <Box
                  display={isPhaseChecked ? "flex" : "none"}
                  flexDirection={{ xs: "column", lg: "row" }}
                  justifyContent={"space-between"}
                  sx={{ mb: 5 }}
                  alignItems={"center"}
                >
                  <Typography
                    sx={{
                      fontSize: { xs: "24px", sm: "28px" },
                      fontWeight: 500,
                      color: darkMode
                        ? getColors.drawerTextDark
                        : getColors.thumbnailTextLight,
                      textAlign: "left",
                      mr: "auto",
                      mb: { xs: 1, sm: 0, md: 1, lg: 0 },
                    }}
                  >
                    {openPhaseSection ? "Selected Phases" : "Phases of Care"}
                  </Typography>

                  <Button
                    variant="contained"
                    startIcon={
                      openPhaseSection ? (
                        <SaveOutlinedIcon
                          style={{ fontSize: 28, marginRight: 8 }}
                        />
                      ) : (
                        <ChangeCircleOutlinedIcon
                          style={{ fontSize: 28, marginRight: 8 }}
                        />
                      )
                    }
                    disabled={!isPhaseChecked}
                    sx={{
                      fontFamily: "Poppins",
                      fontSize: { xs: "16px", sm: "20px" },
                      py: "12px",
                      background: darkMode ? "#2D2E30" : "#E6E6E6",
                      color: darkMode
                        ? getColors.primaryTextDark
                        : getColors.secondaryTextLight,
                      ml: "auto",
                      "&:hover": {
                        color: getColors.primaryTextDark,
                      },
                    }}
                    onClick={handleChangePhases}
                  >
                    {openPhaseSection ? "Save Changes" : "Change Phases"}
                  </Button>
                </Box>
                {openPhaseSection ? (
                  <Box
                    display={isPhaseChecked ? "grid" : "none"}
                    sx={{
                      gridTemplateColumns: {
                        xs: "repeat(1, minmax(0, 1fr))",
                        sm: "repeat(2, minmax(0, 1fr))",
                        md: "repeat(1, minmax(0, 1fr))",
                        lg: "repeat(2, minmax(0, 1fr))",
                        xl: "repeat(3, minmax(0, 1fr))",
                      },
                    }}
                    gap={4}
                    mb={8}
                  >
                    {/* <DndContext
                      sensors={sensors}
                      collisionDetection={closestCenter}
                      onDragEnd={handleDragEnd}
                    >
                      <SortableContext
                        items={currentPhases.map((phase) => phase.id)}
                        strategy={verticalListSortingStrategy}
                      > */}
                    {currentPhases.map((phase, index) => (
                      <SelectedPhaseItem
                        key={index}
                        id={phase.id}
                        {...phase}
                        onRemove={handleDeselectPhase}
                      />
                    ))}
                    {/* </SortableContext>
                    </DndContext> */}
                  </Box>
                ) : (
                  <Box
                    display={isPhaseChecked ? "grid" : "none"}
                    sx={{
                      gridTemplateColumns: {
                        xs: "repeat(1, minmax(0, 1fr))",
                        sm: "repeat(2, minmax(0, 1fr))",
                        md: "repeat(1, minmax(0, 1fr))",
                        lg: "repeat(2, minmax(0, 1fr))",
                        xl: "repeat(3, minmax(0, 1fr))",
                      },
                    }}
                    gap={4}
                    mb={8}
                  >
                    {currentPhases.map((phase, index) => (
                      <CurrentPhaseItem
                        key={index}
                        {...phase}
                        disabled={!isPhaseChecked}
                        onEdit={handleEditCurrentClicked}
                      />
                    ))}
                  </Box>
                )}
                {openPhaseSection && (
                  <Box>
                    <Typography
                      sx={{
                        fontSize: { xs: "24px", sm: "28px" },
                        fontWeight: 500,
                        color: darkMode
                          ? getColors.drawerTextDark
                          : getColors.thumbnailTextLight,
                        textAlign: "left",
                        mb: "30px",
                      }}
                    >
                      Available Phases
                    </Typography>
                    <Box
                      display="grid"
                      sx={{
                        gridTemplateColumns: {
                          xs: "repeat(1, minmax(0, 1fr))",
                          sm: "repeat(2, minmax(0, 1fr))",
                          md: "repeat(1, minmax(0, 1fr))",
                          lg: "repeat(2, minmax(0, 1fr))",
                          xl: "repeat(3, minmax(0, 1fr))",
                        },
                      }}
                      gap={4}
                      mb={8}
                    >
                      {allPhases
                        .filter(
                          (phase) =>
                            !currentPhases.some(
                              (currentPhase) =>
                                currentPhase.phaseid === phase.id
                            )
                        ) // Filter out phases that already exist in currentPhases
                        .map((phase, index) => (
                          <AvailablePhaseItem
                            key={index}
                            {...phase}
                            onAdd={handleAddToSelectedPhase}
                          />
                        ))}
                    </Box>
                  </Box>
                )}

                {!openPhaseSection && (
                  <Box>
                    <Box
                      sx={{
                        display: isTreatmentChecked ? "flex" : "none",
                        mb: 5,
                      }}
                      flexDirection={{ xs: "column", lg: "row" }}
                      justifyContent={"space-between"}
                    >
                      <Typography
                        sx={{
                          fontSize: { xs: "24px", sm: "28px" },
                          fontWeight: 500,
                          color: darkMode
                            ? getColors.drawerTextDark
                            : getColors.thumbnailTextLight,
                          textAlign: "left",
                        }}
                      >
                        Treatments
                      </Typography>
                      <Button
                        variant="contained"
                        startIcon={
                          <Add style={{ fontSize: 28, marginRight: 8 }} />
                        }
                        sx={{
                          fontFamily: "Poppins",
                          fontSize: { xs: "16px", sm: "20px" },
                          py: "12px",
                          background: darkMode ? "#2D2E30" : "#E6E6E6",
                          color: darkMode
                            ? getColors.primaryTextDark
                            : getColors.secondaryTextLight,
                          ml: "auto",
                          "&:hover": {
                            color: getColors.primaryTextDark,
                          },
                        }}
                        onClick={() => setOpenAddTreatmentDialog(true)}
                      >
                        {"Add Treatment"}
                      </Button>
                    </Box>
                    <Typography
                      sx={{
                        display: isTreatmentChecked ? "block" : "none",
                        fontSize: { xs: "18px", sm: "22px" },
                        fontWeight: 500,
                        color: darkMode
                          ? getColors.drawerTextDark
                          : getColors.thumbnailTextLight,
                        textAlign: "left",
                        mb: 2,
                      }}
                    >
                      General
                    </Typography>
                    <Box
                      display={isTreatmentChecked ? "grid" : "none"}
                      sx={{
                        gridTemplateColumns: {
                          xs: "repeat(1, minmax(0, 1fr))",
                          sm: "repeat(2, minmax(0, 1fr))",
                          md: "repeat(1, minmax(0, 1fr))",
                          lg: "repeat(2, minmax(0, 1fr))",
                          xl: "repeat(3, minmax(0, 1fr))",
                        },
                      }}
                      gap={4}
                      mb={4}
                    >
                      {allTreatments.map((treatment, index) => (
                        <AvailableTreatmentItem
                          key={index}
                          {...treatment}
                          onCheck={handleSelectedTreatmentChange}
                          isChecked={selectedTreatments.some(
                            (selected) => selected.name === treatment.name
                          )}
                        />
                      ))}
                    </Box>
                    <Typography
                      sx={{
                        display:
                          isTreatmentChecked && customTreatments.length > 0,
                        fontSize: { xs: "18px", sm: "22px" },
                        fontWeight: 500,
                        color: darkMode
                          ? getColors.drawerTextDark
                          : getColors.thumbnailTextLight,
                        textAlign: "left",
                        mb: 2,
                      }}
                    >
                      Custom
                    </Typography>
                    <Box
                      display={isTreatmentChecked ? "grid" : "none"}
                      sx={{
                        gridTemplateColumns: {
                          xs: "repeat(1, minmax(0, 1fr))",
                          sm: "repeat(2, minmax(0, 1fr))",
                          md: "repeat(1, minmax(0, 1fr))",
                          lg: "repeat(2, minmax(0, 1fr))",
                          xl: "repeat(3, minmax(0, 1fr))",
                        },
                      }}
                      gap={4}
                      mb={8}
                    >
                      {customTreatments.map((treatment, index) => (
                        <SelectedCustomTreatmentItem
                          key={index}
                          {...treatment}
                          onCheck={handleSelectedCustomTreatmentChange}
                          isChecked={selectedCustomTreatments.some(
                            (selected) => selected.id === treatment.id
                          )}
                          onTreatmentUpdate={updateCustomTreatment}
                        />
                      ))}
                    </Box>
                    <CitationSelection
                      citations={selectedTreatments}
                      onSelectionChange={handleCheckedCitationItemsChange}
                      checkedIDs={initialCitationIDs}
                      disabled={!isCitationChecked}
                    />
                    <ProtocolSelection
                      customProtocolData={customProtocolData}
                      ebprotocolData={ebprotocolData}
                      onSelectionChange={handleProtocolSelectionChange} // Pass the callback
                      checkedID={initialProtocolIDs}
                      disabled={!isExerciseChecked}
                    />
                    <CarePlanEstimation
                      onCheckedItemsChange={handleCheckedEstimationItemsChange}
                      checkedIDs={initialCheckedIDs} // IDs to be pre-checked
                      disabled={!isEstimationChecked}
                    />
                  </Box>
                )}
              </Box>
            ))}
        </>
      </Box>

      <SendDialog
        open={sendDialogOpen}
        setOpen={setSendDialogOpen}
        careplanData={currentCareplanData}
      />

      <PhaseDialog
        open={phaseDialogOpen}
        onClose={handleCloseDialog}
        phaseData={phaseToEdit}
        onCopy={handleCopyNewPhase}
        onEdit={handleEditPhase}
        onCurrentEdit={handleEditCurrentPhase}
        onDelete={handleDeletePhase}
        actionType={phaseActionType}
      />

      <AddTreatmentDialog
        open={openAddTreatmentDialog}
        onClose={handleCancelAddTreatmentDialog}
        onAdd={handleAddCustomTreatment}
      />
    </Box>
  );
};
